import { cssVars } from '@/styles/Themes/cssVars';
import Screen from '@/styles/Themes/Screen';
import styled, { css } from 'styled-components';
import Text from 'src/styles/Themes/Text';
import Palette from '@/styles/Themes/Palette';
import { radius } from 'src/styles/Themes/Metrics';
import emptyattraction_ipad from '@/shared/images/Images/emptyattraction_ipad.png';
import emptyattraction_ipad_dark from '@/shared/images/Images/emptyattraction_ipad_dark.png';
import emptyattraction_mobile from '@/shared/images/Images/emptyattraction_mobile.png';
import emptyattraction_mobile_dark from '@/shared/images/Images/emptyattraction_mobile_dark.png';
import emptyattraction_desktop_dark from '@/shared/images/Images/emptyattraction_desktop_dark.png';
import emptyattraction_desktop from '@/shared/images/Images/emptyattraction_desktop.png';
import { Transition } from '@/styles/Themes/KeyFrames';
import { DropdownArrow } from '@/shared/images/icons/DropdownArrow';

export const Container = styled.div`
    padding: 0 17px;

    ${Screen.ipad} {
        padding: 0 28px;
    }
    ${Screen.desktop} {
        padding: 0;
        width: 1064px;
        margin: auto;
    }
`;

export const ActivityWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 14px;
    margin-bottom: 20px;

    ${Screen.ipad} {
        grid-gap: 30px;
        margin-bottom: 30px;
    }

    ${Screen.desktop} {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr;
        margin: 10px 0 30px;
    }
`;

export const Title = styled.h1`
    color: ${cssVars.fg_gray1_white};
    margin: 0 0 35px;
    ${Text.Mobile.heading2};

    ${Screen.ipad} {
        ${Text.Mobile.heading3};
    }

    ${Screen.desktop} {
        ${Text.Mobile.heading2};
    }
`;

export const ActivityTitle = styled.div`
    margin: 0 0 20px;
    color: ${cssVars.fg_gray2_gray3};
    display: flex;
    align-items: center;
    cursor: pointer;
    > svg {
        transform: rotate(270deg) translate(0, 0);
        fill: ${cssVars.bg_green_dark3};
    }
`;

export const EmptyPartnerPageContainer = styled.div`
    width: 90%;
    margin: 10px auto;

    ${Screen.desktop} {
        width: 1124px;
        padding: 30px;
        margin: 0 auto;
    }
`;

export const EmptyPartnerMessageContainer = styled.div`
    border-radius: ${radius.small};
    background-color: ${cssVars.bg_ash_dark2};
    text-align: center;
    margin: 0 auto 20px;
    padding: 16px;
`;

export const EmptyPartnerMessage = styled.div`
    ${Text.Mobile.caption.medium};
    color: ${cssVars.fg_gray2_gray3};

    ${Screen.desktop} {
        ${Text.Desktop.large.medium};
    }
`;

export const GoBackButton = styled.a`
    cursor: pointer;
    color: ${Palette.green.normal};

    ${Screen.desktop} {
        ${Text.Desktop.heading4};
    }
    &:hover {
        text-decoration: underline;
    }
`;

export const ImageContainer = styled.div<{ isLight: boolean }>`
    background-image: ${({ isLight }) =>
        isLight ? `url(${emptyattraction_mobile.src})` : `url(${emptyattraction_mobile_dark.src})`};
    width: 100%;
    height: 217px;
    margin: 50px auto 0;

    ${Screen.ipad} {
        width: 578px;
        height: 417px;
        margin: 80px auto 90px;
        background-image: ${({ isLight }) =>
            isLight ? `url(${emptyattraction_ipad.src})` : `url(${emptyattraction_ipad_dark.src})`};
    }
    ${Screen.desktop} {
        width: 646px;
        height: 466px;
        margin: 100px auto 0;
        background-image: ${({ isLight }) =>
            isLight
                ? `url(${emptyattraction_desktop.src})`
                : `url(${emptyattraction_desktop_dark.src})`};
    }
`;

export const Description = styled.div<{ isActive: boolean }>`
    ${Text.Full.large.regular};
    margin: 10px 0 0;
    color: ${cssVars.fg_gray1_white};
    max-height: ${({ isActive }) => (isActive ? 'fit-content' : '80px')};
    overflow: hidden;

    ${Screen.desktop} {
        margin: 30px auto 0;
    }
    p {
        margin: 10px 0;
    }
`;

export const WrapperSubscribe = styled.div`
    > div {
        padding: 50px 0;

        ${Screen.ipad} {
            padding: 60px 0;
        }
    }
`;

export const ReadMore = styled.span<{ isActive: boolean }>`
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 36px;
    ${Text.Full.medium.medium}
    color: ${Palette.green.normal};
    ${Transition.normal};
    margin-bottom: 13px;
    cursor: pointer;
    position: relative;

    ${({ isActive }) =>
        !isActive &&
        css`
            box-shadow: 0px -8px 16px 8px ${cssVars.bg_white_blue};
        `}
`;

export const Arrow = styled(DropdownArrow)<{ isActive: boolean }>`
    margin-left: 6px;
    fill: ${Palette.green.normal};
    ${({ isActive }) => isActive && 'transform: rotate(-180deg);'}
    ${Transition.normal};
`;
